export enum SortalysUserAccess {
  CUSTOMER = 'customer',
  HQ = 'hq',
  SALES_REPRESENTATIVE = 'sales_representative',
}
